export default "__VITE_ASSET__D_V8YtMv__"